module.exports = __webpack_public_path__ + "img/setting.c1369d4f.svg";